/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const ResumeTransactionHeader = ({
  transactionNumber,
}) => {
  const {
    RL_ResumeTransaction, RL_TRANSACTION
  } = useSelector((state) => state);

  return (
    <>
      <p>{RL_ResumeTransaction}</p>
      <p>{RL_TRANSACTION}: {transactionNumber}</p>
    </>
  );
};

ResumeTransactionHeader.propTypes = {
  transactionNumber: PropTypes.number.isRequired,
};

export default ResumeTransactionHeader;
